import { Heading, Highlight } from '@chakra-ui/react';
import { Form, pushToDataLayer } from '@repo/shared/shared';
import { useTranslation } from 'next-i18next';
import { useForm } from 'react-hook-form';
import { useGlobalState } from '@/shared/providers';
import { DefaultContainer, Slider } from '@/shared/ui';
import { localStorage } from '@/shared/utils';
import { IQuizForm } from '../lib/generateQuizResponse';
import { getQuizStepsData } from '../lib/quizStepsData';

const NewCustomerForm = () => {
  const { t } = useTranslation();
  const { setQuizResult } = useGlobalState();
  const quizStepsData = getQuizStepsData(t);

  const methods = useForm<IQuizForm>({
    defaultValues: {
      locationsCount: '',
      monthlyCustomers: '',
      reviewPlatforms: [],
      otherReviewPlatforms: '',
      crmPlatforms: [],
      otherCrmPlatforms: '',
      interestedSolutions: [],
      otherInterestedSolutions: '',
      isUseReviewManagers: '',
      otherReviewManagers: '',
    },
  });

  const onSubmit = (formData: IQuizForm) => {
    const stringifiedQuiz = JSON.stringify({
      ...formData,
      timeStamp: Math.floor(Date.now() / 1000),
    });
    localStorage.setItem('quiz', stringifiedQuiz);
    setQuizResult(stringifiedQuiz);
    pushToDataLayer('new_customer_form_sended');
  };

  return (
    <DefaultContainer
      alignItems='center'
      bg={{ base: 'bg.light', md: 'bg.pure' }}
      gap='xl'
      pb='0'
    >
      <Form
        childrenContainerProps={{
          gap: 'xl',
          textAlign: 'center',
          alignItems: 'center',
          bg: 'bg.light',
          py: { base: 10, md: 20 },
          px: { base: 0, md: 'xl' },
          borderRadius: 'xl',
          w: 'full',
        }}
        formId='newCustomerForm'
        methods={methods}
        onSubmit={onSubmit}
      >
        <Heading
          size='xl'
          whiteSpace='pre-wrap'
        >
          <Highlight
            query={[t('mainPage.newCustomerForm.highlight')]}
            styles={{ color: 'primary.pure' }}
          >
            {methods.formState.isSubmitted
              ? t('mainPage.newCustomerForm.submitted')
              : t('mainPage.newCustomerForm.heading')}
          </Highlight>
        </Heading>
        <Slider
          methods={methods}
          steps={quizStepsData}
        />
      </Form>
    </DefaultContainer>
  );
};

export default NewCustomerForm;
